export const trackEvent = (event: string, props?: Record<string, any>) => {
    if (props) {
        (window as any).amplitude.getInstance().logEvent(event, props);
    } else {
        (window as any).amplitude.getInstance().logEvent(event);
    }
};
